export default __webpack_public_path__ + "static/media/springboot.51bcbd1e.jpg";